/** Organizer-facing event format names — never expose internal framework codes in UI. */
const FORMAT_LABELS: Record<string, string> = {
  simulation: 'Model United Nations',
  mun: 'Model United Nations',
  parliamentary: 'Parliamentary Debate / Assembly',
  state_legislative: 'State Legislative Assembly',
  innovation: 'Hackathon',
  assessment: 'Quiz Competition',
  learning: 'Workshop',
  conference: 'Conference',
  custom: 'Custom Event',
  cultural: 'Cultural Festival',
  hackathon: 'Hackathon',
  codeathon: 'Codeathon',
  workshop: 'Workshop',
  startup: 'Startup Pitch',
  college_fest: 'College Fest',
  other: 'General Event',
};

export function friendlyFormatLabel(codeOrLabel?: string | null, fallback = 'Your Event'): string {
  if (!codeOrLabel) return fallback;
  const key = codeOrLabel.toLowerCase().trim().replace(/\s+/g, '_');
  if (FORMAT_LABELS[key]) return FORMAT_LABELS[key];
  if (codeOrLabel.includes(' ')) return codeOrLabel;
  return codeOrLabel
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function friendlyModuleTitle(slug: string): string {
  const map: Record<string, string> = {
    'event-type-module': 'Event Program',
    'event-settlements': 'Settlements & Payouts',
    evaluation: 'Evaluation settings',
    discovery: 'Discovery settings',
    visibility: 'Visibility & sales',
    'sale-window': 'Visibility & sales',
    'bank-details': 'Finance settings',
    'email-campaigning': 'Email Campaigning',
    'organizer-team': 'Organizer Team',
    'permission-letter': 'Permission Letter',
  };
  return map[slug] ?? slug.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}
